import PromiseToPayReportActionTypes from './promise-to-pay-report.type';

/***************** GET PROMISE TO PAY REPORT START ************* */
export const getPromiseToPayReportListStart = (getData: any) => ({
	type: PromiseToPayReportActionTypes.GET_PROMISE_TO_PAY_REPORT_LIST_START,
	payload: getData,
});

export const getPromiseToPayReportListSuccess = (successData: any) => ({
	type: PromiseToPayReportActionTypes.GET_PROMISE_TO_PAY_REPORT_LIST_SUCCESS,
	payload: successData,
});

export const getPromiseToPayReportListFailure = (failureData: any) => ({
	type: PromiseToPayReportActionTypes.GET_PROMISE_TO_PAY_REPORT_LIST_FAILURE,
	payload: failureData,
});

export const getPromiseToPayReportListResponseResetStart = () => ({
	type: PromiseToPayReportActionTypes.GET_PROMISE_TO_PAY_REPORT_LIST_RESPONSE_RESET,
});

export const getPromiseToPayReportListResponseChanged = () => ({
	type: PromiseToPayReportActionTypes.GET_PROMISE_TO_PAY_REPORT_LIST_RESPONSE_CHANGED,
});
/***************** GET PROMISE TO PAY REPORT END ************* */

/******* START FETCH GROUP LOAN OFFICER LIST ***********/
export const fetchGroupLoanOfficerListStart = (getData: any) => ({
	type: PromiseToPayReportActionTypes.FETCH_GROUP_LOAN_OFFICER_LIST_START,
	payload: getData,
});

export const fetchGroupLoanOfficerListSuccess = (successData: any) => ({
	type: PromiseToPayReportActionTypes.FETCH_GROUP_LOAN_OFFICER_LIST_SUCCESS,
	payload: successData,
});

export const fetchGroupLoanOfficerListFailure = (failureData: any) => ({
	type: PromiseToPayReportActionTypes.FETCH_GROUP_LOAN_OFFICER_LIST_FAILURE,
	payload: failureData,
});

export const fetchGroupLoanOfficerListResponseResetStart = () => ({
	type: PromiseToPayReportActionTypes.FETCH_GROUP_LOAN_OFFICER_LIST_RESPONSE_RESET,
});

export const fetchGroupLoanOfficerListResponseChanged = () => ({
	type: PromiseToPayReportActionTypes.FETCH_GROUP_LOAN_OFFICER_LIST_RESPONSE_CHANGED,
});
/******* END FETCH GROUP LOAN OFFICER LIST ***********/

/******************* GET PROMISE TO PAY REPORT EXCEL START *********************** */
export const getPromiseToPayReportExcelStart = (getData: any) => ({
	type: PromiseToPayReportActionTypes.GET_PROMISE_TO_PAY_EXCEL_START,
	payload: getData,
});

export const getPromiseToPayReportExcelSuccess = (successData: any) => ({
	type: PromiseToPayReportActionTypes.GET_PROMISE_TO_PAY_EXCEL_SUCCESS,
	payload: successData,
});

export const getPromiseToPayReportExcelFailure = (failureData: any) => ({
	type: PromiseToPayReportActionTypes.GET_PROMISE_TO_PAY_EXCEL_FAILURE,
	payload: failureData,
});

export const getPromiseToPayReportExcelResponseResetStart = () => ({
	type: PromiseToPayReportActionTypes.GET_PROMISE_TO_PAY_EXCEL_RESPONSE_RESET_START,
});

export const getPromiseToPayReportExcelResponseChanged = () => ({
	type: PromiseToPayReportActionTypes.GET_PROMISE_TO_PAY_EXCEL_RESPONSE_CHANGED,
});
/** ***************** GET PROMISE TO PAY REPORT EXCEL END *********************** */
